import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"

import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "10px" : "0")};
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  fullName: all.store.trafficLookup.fullName,
  changeKey: all.store.trafficLookup.changeKey,
}))
@observer
class FullNameInput extends Component {
  handleChange = (e) => {
    this.props.changeKey("fullName", e.target.value)
  }

  render() {
    const fullNameErrorHandler = this.props.validateDisplayMessage("fullName")
    const compact = this.props.compact
    return (
      <Wrap $compact={compact}>
        <InputTitle htmlFor="fullName">
          {this.props.translate("label")}
          {!compact && <Spacer direction="width" mobile={11} desktop={11} />}
        </InputTitle>
        {!compact && <Spacer desktop={16} mobile={4} />}
        <Input
          id="fullName"
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChange}
          value={this.props.fullName}
          error={fullNameErrorHandler}
          autoFocus={this.props.autofocus}
        />
        <FormError error={fullNameErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(FullNameInput, "form.general.fullName")
